import * as React from 'react';
import {useEffect} from 'react';
import {Paper, Button, Stack, Typography, Box, Chip} from '@mui/material';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useItemDetail} from './hooks/useItemDetail';
import {useParams} from 'react-router-dom';
import parse from 'html-react-parser';
import {usePoliceMode} from '../policeMode/hook/usePoliceMode';

const ItemDetailDescription = ({item, loading}) => {
  const {mode} = useDarkMode();
  const [showDescription, setShowDescription] = React.useState(true);
  const {police} = usePoliceMode();

  console.log('item', item);
  return (
    !loading &&
    item && (
      <Stack sx={{maxWidth: '500px', padding: '5px'}} spacing={2}>
        <Box
          sx={{
            height: '460px',
            maxWidth: '460px',
            width: '100%',
            backgroundColor: 'yellow',
            backgroundImage: `url(${item.product.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}>
          <Box
            sx={{
              marginTop: '15px',
              marginLeft: '15px',
              color: 'white',
              backgroundColor: mode.settings.textColor6,
              width: '130px',
              height: '40px',
              borderRadius: '5px',
            }}>
            <Stack
              direction={'row'}
              alignItems={'center'}
              style={{width: '100%', height: '100%'}}
              justifyContent={'space-around'}>
              <img
                src={`/assets/icon/${item.product.category}-white.png`}
                alt="service"
              />
              <Typography variant="subtitle1" component="span">
                {(item.product.category + '').charAt(0).toUpperCase() +
                  (item.product.category + '').substring(1)}
              </Typography>
            </Stack>
          </Box>
        </Box>
        {showDescription ? (
          <Box
            sx={{
              height: '40px',
              maxWidth: '399px',
              width: '100%',
              backgroundColor: mode.settings.card3BackgroundColor,
              padding: '8px 16px 8px 16px',
            }}>
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}>
              <Button
                className="btn-gradient"
                variant="contained"
                size="small"
                sx={{width: '30%', borderRadius: '10px !important'}}
                aria-label={'Description'}>
                <Typography variant={'subtitle3'}>Description</Typography>
              </Button>
              <Typography
                variant={'subtitle3'}
                sx={{
                  marginLeft: '25px',
                  color: mode.settings.textColor7,
                  cursor: 'pointer',
                }}
                onClick={() => setShowDescription(false)}>
                Comment ça marche ?
              </Typography>
            </Stack>
          </Box>
        ) : (
          <Box
            sx={{
              height: '40px',
              maxWidth: '399px',
              minWidth: '400px',
              width: '100%',
              backgroundColor: mode.settings.card3BackgroundColor,
              padding: '8px 16px 8px 16px',
            }}>
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}>
              <Typography
                variant={'subtitle3'}
                sx={{
                  marginLeft: '25px',
                  color: mode.settings.textColor7,
                  cursor: 'pointer',
                }}
                onClick={() => setShowDescription(true)}>
                Description
              </Typography>
              <Button
                className="btn-gradient"
                variant="contained"
                size="small"
                sx={{width: '60%', borderRadius: '10px !important'}}
                aria-label={'Description'}>
                <Typography variant={'subtitle3'}>Comment ça marche</Typography>
              </Button>
            </Stack>
          </Box>
        )}

        {showDescription ? (
          <Box
            sx={{
              width: '432px',
            }}>
            <Typography
              variant={'subtitle3'}
              sx={{marginLeft: '25px', color: mode.settings.textColor7}}>
              {parse(item.product.description)}
            </Typography>
              {item.product.seller && <Chip
                  sx={{
                      height: 'auto',
                      '& .MuiChip-label': {
                          display: 'block',
                          whiteSpace: 'normal',
                      },
                      padding: '5px',
                      color : mode.settings.textColor7,
                      backgroundColor: mode.settings.card3BackgroundColor,
                      fontFamily: police.normalMode ? 'Roboto' : 'Dyslexic',
                  }}
              label={`${item.product.seller}  ${item.product.shopAddress}  ${item.product.shopTel} ${item.product.shopContact} ${item.product.shopEmail}`}
            />}
          </Box>
        ) : (
          <Box
            sx={{
              width: '429px',
            }}>
            <Typography
              variant={'subtitle3'}
              sx={{marginLeft: '25px', color: mode.settings.textColor7}}>
              {parse(item.product.howTo)}
            </Typography>
          </Box>
        )}
      </Stack>
    )
  );
};

export default ItemDetailDescription;
